import { FormSectionConfig } from '../AddRoom/Washroom/washroomJson';

export const getOptionLabel = (
  config: FormSectionConfig[],
  value: string,
): string => {
  for (const section of config) {
    const controls = [
      ...(section.controls ?? []),
      ...(section.group?.controls ?? []),
    ];

    for (const control of controls) {
      if ('options' in control) {
        const option = control.options.find((o) => o.value === value);

        if (option) {
          return option.label;
        }
      }
    }
  }

  return value;
};
